import apiClient from './api';
import {
  PedidoAPI,
  ListarPedidosResponse,
  CrearPedidoRequest,
  ActualizarPedidoRequest,
  CambiarEstadoRequest,
  MetricasPedidos,
  FiltrosPedidos,
} from '../types/pedidos';

// Clase para manejar todas las operaciones de la API de pedidos
export class PedidosAPI {
  private basePath = '/pedidos';

  // GET /api/pedidos - Listar pedidos con filtros
  async listar(
    filtros: FiltrosPedidos = {},
    page = 1,
    limit = 10
  ): Promise<ListarPedidosResponse> {
    const params = new URLSearchParams();

    // Agregar parámetros de paginación
    params.append('page', page.toString());
    params.append('limit', limit.toString());

    // Agregar filtros si existen
    if (filtros.estado) params.append('estado', filtros.estado);
    if (filtros.clienteId) params.append('clienteId', filtros.clienteId);
    if (filtros.fechaDesde) params.append('fechaDesde', filtros.fechaDesde);
    if (filtros.fechaHasta) params.append('fechaHasta', filtros.fechaHasta);
    if (filtros.soloHoy) params.append('soloHoy', 'true');
    if (filtros.soloManana) params.append('soloManana', 'true');
    if (filtros.minutaVigente) params.append('minutaVigente', 'true');
    if (filtros.hoy) params.append('hoy', filtros.hoy);

    const response = await apiClient.get(
      `${this.basePath}?${params.toString()}`
    );
    return response.data;
  }

  // GET /api/pedidos/:id - Obtener pedido específico
  async obtener(id: string): Promise<PedidoAPI> {
    const response = await apiClient.get(`${this.basePath}/${id}`);
    return response.data;
  }

  // POST /api/pedidos - Crear nuevo pedido
  async crear(datos: CrearPedidoRequest): Promise<PedidoAPI> {
    const response = await apiClient.post(this.basePath, datos);
    return response.data;
  }

  // PUT /api/pedidos/:id - Actualizar pedido
  async actualizar(
    id: string,
    datos: ActualizarPedidoRequest
  ): Promise<PedidoAPI> {
    const response = await apiClient.put(`${this.basePath}/${id}`, datos);
    return response.data;
  }

  // PATCH /api/pedidos/:id/estado - Cambiar estado del pedido
  async cambiarEstado(
    id: string,
    datos: CambiarEstadoRequest
  ): Promise<PedidoAPI> {
    const response = await apiClient.patch(
      `${this.basePath}/${id}/estado`,
      datos
    );
    return response.data;
  }

  // DELETE /api/pedidos/:id - Eliminar pedido
  async eliminar(id: string): Promise<{ message: string }> {
    const response = await apiClient.delete(`${this.basePath}/${id}`);
    return response.data;
  }

  // GET /api/pedidos/metricas - Obtener métricas del dashboard
  async obtenerMetricas(): Promise<MetricasPedidos> {
    const response = await apiClient.get(`${this.basePath}/metricas`);
    return response.data;
  }
}

// Instancia única para exportar
export const pedidosAPI = new PedidosAPI();
